import { render } from "./confirmduplicate.vue?vue&type=template&id=18b6d32b"
import script from "./confirmduplicate.vue?vue&type=script&lang=js"
export * from "./confirmduplicate.vue?vue&type=script&lang=js"

import "./confirmduplicate.vue?vue&type=style&index=0&id=18b6d32b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__